import {RailsApi} from '@/api/rails.api.js'
import {Organization} from '@/models/organization.model.js'

/**
 * Organization API service
 *
 * NOTE: This API is for the current organization (singular)
 */
export class OrganizationApi extends RailsApi {

  //Props
  basePath = '/organization'
  itemKey = 'organization'
  ModelClass = Organization

  /**
   * Get current organization
   */
  getCurrent() {
    return this
      .get(`/`)
      .then(json => this.toModelInstance(json))
  }

  /**
   * Switch the current organization
   */
  switchCurrent(organizationId) {
    return this
      .post(`/switch_current_organization`, {organizationId})
      .then(json => this.toModelInstance(json))
  }
}

//Export singleton instance
export const organizationApi = new OrganizationApi()
